import {Callout} from '@blueprintjs/core';
import React, {PureComponent} from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import ReactDOM from 'react-dom'
import Intercom from 'react-intercom';
import Joyride, {ACTIONS, CallBackProps, EVENTS, STATUS, Step} from 'react-joyride';

import toastr from "toastr";
import http from "../../services/httpService";

import Subscribers from '../../components/views/Subscribers'
import Dashboard from '../../components/views/Dashboard'
import Feeds from '../../components/views/Feeds'
import Settings from '../../components/views/Settings'
import Subscription from '../../components/views/Subscription'

import KnowledgeBase from '../../components/views/KnowledgeBase'

import Billing from '../../components/views/billing/Billing'
import Teams from '../../components/views/Teams'
import FacebookMessageCustomPost from '../../components/views/FacebookMessageCustomPost'
import Navigation from '../../components/common/Navigation'
import TopHeader from '../../components/common/TopHeader'
import Campaigns from '../../components/views/Campaigns'
import FacebookSponsoredMessage from '../../components/views/FacebookSponsoredMessage';
import AcquireSubscribers from '../../components/views/AcquireSubscribers';
import Tags from '../../components/views/Tags';
import ContentAutomation from '../../components/views/ContentAutomation';
import ApiSettings from '../../components/views/ApiSettings';
import FreePlanPreview from '../views/FreePlanPreview';
import InactivePlanPreview from '../views/InactivePlanPreview';
import RedeemCode from '../views/RedeemCode';
import ViberBusinessMessage from '../views/Viber';

import ProtectedRoute from '../../components/common/protectedRoute'

import EmailModal from '../../components/modals/EmailModal';
import DeleteTagModal from '../../components/modals/DeleteTagModal';
import PasswordModal from '../../components/modals/PasswordModal';
import TeamModal from '../../components/modals/TeamModal';
import {getCurrentUserId, getCurrentUserName, getJwt} from '../../services/authService';
import InviteAdminsFeedModal from '../modals/InviteAdminsFeedModal';
import AddAdminsTeamModal from '../../components/modals/AddAdminsTeamModal';
import EditTeamModal from '../../components/modals/EditTeamModal';
import DeleteTeamModal from '../../components/modals/DeleteTeamModal';
import DeleteFeedModal from '../../components/modals/DeleteFeedModal';
import ActivationModal from '../../components/modals/ActivationModal';
import PostReachModal from '../../components/modals/PostReachModal';
import ConnectBotToPageModal from '../../components/modals/ConnectBotToPageModal';
import ReassignFeedModal from '../../components/modals/ReassignFeedModal';
import FeedInfoEditModal from '../../components/modals/FeedInfoEditModal';
import DeleteRssModal from '../../components/modals/DeleteRssModal';
import FacebookVideoModal from '../../components/modals/FacebookVideoModal';
import WebpushVideoModal from '../../components/modals/WebpushVideoModal';
import OverviewVideoModal from '../../components/modals/OverviewVideoModal';
import ContactSupportModal from '../../components/modals/ContactSupportModal';
import ConnectViberModal from '../../components/modals/ConnectViberModal';
import Sms from '../../components/views/Sms';
// import ReactGA from 'react-ga';
import NoFeeds from "../views/feed/NoFeeds";
import CreateTagModal from "../modals/CreateTagModal";
import TagModal from "../modals/EditTagModal";

import CampaignPerformance from '../views/CampaignPerformance';
import DistributionChannels from '../views/distributionChannels/DistributionChannels';
import Channels from '../views/Channels';
import DeleteSubscribersModal from "../modals/DeleteSubscribersModal";

import ImportContacts from '../views/contacts/ImportContacts';
import Contacts from '../views/contacts/Contacts';
import UrlShortener from "../views/UrlShortener";
import SMSInbox from "../views/SMSInbox";
import CustomizeShortLinkModal from "../modals/CustomizeShortLinkModal";

import CustomFields from "../views/CustomFields";

//import {StripeProvider} from 'react-stripe-elements';


class Main extends PureComponent {

    state = {
        editing: false,
        target_page_to_connect: {slot: ""},
        loadingPostReach: false,
        menuActive: false,
        firstLoad: true,
        selectedSource: this.props.selectedSource,
        plansData: this.props.plansData,
        currentPlan: '',
        currentPlanLimitations: '',
        user: this.props.user,
        selectedSourceFull: '',
        projectPaymentMethod: '',
        platformsEnabled: [],

        //tour settings
        tourRun: false,
        stepIndex: 0,
        steps: [],
        tourType: '',

//top header hiding controls
        passedTop: false,
        show: true,
        scrollPos: 0,
        openProfileFromMain: false

    };


    loadingSubscribers = (loading) => {
        // console.log('loading in main js:', loading);
        this.setState({
            loadingPostReach: loading
        });
        //console.log('loading subscribers in modal:', this.state.loadingPostReach)
    };

    addSource = (e) => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: '+ New Feed',
        //     label: '',
        //     userId: getCurrentUserId(),
        //     nonInteraction: true
        // });
        this.props.history.push('/workspace-name');
    };


    analytics = () => {
        // ReactGA.set({userId: getCurrentUserId()});
        // ReactGA.pageview(window.location.pathname + window.location.search);
    };

    menuFixer = () => {
        if (document.querySelector('.dashboard-menu')) {
            if (window.screen.width > 1023) {
                document.querySelector('.dashboard-menu').style.display = 'block';
                document.querySelector('.dash-logo-img').style.display = 'block';
            } else {
                document.querySelector('.dashboard-menu').style.display = 'none';
                document.querySelector('.dash-logo-img').style.display = 'none';
            }
        }
    };


    toggleClosePanel = (e) => {
        if (e.target.nextSibling.classList.contains('d-block')) {
            e.target.nextSibling.classList.remove('d-block')
        } else {
            e.target.nextSibling.classList.add('d-block')
        }
    };

    getHelpers = (StoreHelpers) => {
        this.helpers = StoreHelpers;
    };

    handleJoyrideCallback = (data) => {

        //console.log('joyride callback data: ', data)
        const {status} = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];
        const sideMenu = document.querySelector('.dashboard-menu-container')

        //console.log('sideMenu: ', sideMenu)

        if (finishedStatuses.includes(status)) {
            this.setState({tourRun: false});
        }
        this.setState({
            passedTop: false, show: true
        })

        if ((data.action === 'next' || data.action === 'update') && data.index >= 4 && this.state.tourType === 2) {
            //console.log('scroll-menu')
            sideMenu.scroll({
                top: (data.index - 4) * 28, // behavior: "smooth"
            })
        }
        if (this.state.tourType === 2) {
            let body = document.querySelector('body')

            if (data.index === 12) {

                this.setState({
                    passedTop: false, show: true, scrollPos: 0, openProfileFromMain: true
                })
            }
            if (data.index === 13) {
                // console.log('move body')
                setTimeout(() => {
                    window.scroll({
                        top: 5
                    })
                }, 300)
                setTimeout(() => {
                    window.scroll({
                        top: 5
                    })
                }, 300)
                setTimeout(() => {
                    window.scroll({
                        top: 5
                    })
                }, 300)

            }
            if (data.index === 13 && data.status === "finished") {
                this.setState({

                    openProfileFromMain: false
                })
                this.props.history.push('/billing/balance', 'first-workspace')
            }
        }

    }
    componentDidMount = async () => {


        // console.log('componentDidMount Main.js')
        //console.log('REACT_SETTING: ', process.env.REACT_APP_ENVIRONMENT)
        if (!this.state.user.sources.data.length) {
            //console.log('run 1')
            this.setState({
                tourRun: true, steps: [{
                    content: "I'm going to show you how to get the most out of Emitto. But first, let's see the basics!",
                    placement: 'center',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.onboarding-tour-step-1',
                    title: 'Welcome aboard!🛳',
                }, {
                    content: "In the sidebar menu you'll find everything you need to set up different channels, manage your audience, create campaigns and analyze their progress.",
                    placement: 'right-start',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.onboarding-tour-step-2',
                    title: 'Main Navigation 🌟',
                }, {
                    content: "Update your profile, manage teams and billing details associated with your account and workspace.",
                    placement: 'bottom',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.onboarding-tour-step-3',
                    title: 'Account Settings ⚙️',
                }, {
                    content: "You can reach the team anytime from the bottom right corner of your screen.",
                    placement: 'top',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.intercom-lightweight-app-launcher-icon',
                    title: "You're ready to proceed! 🍻",
                }, {
                    content: "You should use workspaces to keep different clients or brands separate and organized.",
                    placement: 'right',
                    spotlightPadding: 0,
                    styles: {
                        options: {
                            zIndex: 10000,
                        },
                    },
                    target: '.onboarding-tour-step-5',
                    title: "Let's create your first workspace! 🤩",
                }], tourType: 1
            })
        } else {
            // console.log('this.props.location.state: ', this.props.location.state)
            // console.log('this.state.user.sources.data.length: ', this.state.user.sources.data.length)
            //console.log('run 2')
            let steps = ''
            if (process.env.REACT_APP_ENVIRONMENT === 'DEV') {
                steps = [

                    {
                        content: "Let's hop on a quick tour around the platform together!",
                        placement: 'center',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-1',
                        title: 'Congrats on creating your first workspace! 😎',
                    }, {
                        content: "Switch between your workspaces instantly from this dropdown menu.",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-2',
                        title: '',
                    }, {
                        content: <div>
                            <p>This will be your favorite place. 🤗</p>
                            <p>Start New Campaigns across all channels
                                here. To run campaigns you first need to enable and set-up all the channels you
                                want to use.</p>
                        </div>,

                        placement: 'right-bottom', spotlightPadding: 0, styles: {
                            options: {
                                zIndex: 10000,
                            },
                        }, target: '.first-workspace-tour-step-3', title: '',
                    }, {
                        content: "Dashboard represents an overview of some high-level statistics. 📊",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-4',
                        title: '',
                    },

                    {
                        content: "My Campaigns keep all your detailed analytics in one place.\n" + "It's the easiest way to compare your campaign performance across channels. Compare 🍏 and 🍏.",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-5',
                        title: '',
                    }, {
                        content: "Emitto has its own URL Shortener.\n" + "Short links make your posts look clean and give you the link-tracking superpower.\n" + "You can even add UTM Tags. 😎\n",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-6',
                        title: '',
                    }, {
                        content: "This is where you can find your FB Messenger and WebPush Subscribers.",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-7',
                        title: '',
                    }, {

                        content: "And here are all the Contacts waiting for SMS and Viber campaigns.",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-8',
                        title: '',
                    }, {
                        content: "Here you can enable and set-up all available Channels. 💬",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-9',
                        title: '',
                    }, {
                        content: "Want to use automatic RSS to WebPush notifications? Manage your content sources here.",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-10',
                        title: '',
                    }, {
                        content: "Tags are used to manage and segment your audience. You can use tags to create highly targeted campaigns. 🎯\n",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-11',
                        title: '',
                    }, {
                        content: "Need to rename your Workspace or Add Workspace Admins? Hop on to Workspace Settings.",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-12',
                        title: '',
                    },


                    {
                        content: "Profile settings and billing details are accessible from your account menu.",


                        placement: 'left', spotlightClicks: true, spotlightPadding: 0, styles: {
                            options: {
                                zIndex: 10000,
                            },
                        }, target: '.first-workspace-tour-step-13', title: '',
                    }, {
                        content: "These are your account settings. From here you can control your profile, payments and teams.\n" + "Let's hop on to billing!",
                        placement: 'left-top',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-14',
                        title: '',
                    }, // {
                    //     content: "All your subscriptions, invoices and billing details are located here. 👉",
                    //     placement: 'left-top',
                    //     spotlightPadding: 0,
                    //     styles: {
                    //         options: {
                    //             zIndex: 10000,
                    //         },
                    //     },
                    //     target: '.first-workspace-tour-step-15',
                    //     title: '',
                    // },
                    // {
                    //     content: "Preview, download or print your Invoices from this section of your account.",
                    //     placement: 'left',
                    //     spotlightPadding: 0,
                    //     styles: {
                    //         options: {
                    //             zIndex: 10000,
                    //         },
                    //     },
                    //     target: '.first-workspace-tour-step-16',
                    //     title: '',
                    // },
                    // {
                    //     content: "If you find Emitto super valuable, you can easily upgrade your plan from here. 😉\n" +
                    //         "Also, here you can also find all your Subscriptions.",
                    //     placement: 'left',
                    //     spotlightPadding: 0,
                    //     styles: {
                    //         options: {
                    //             zIndex: 10000,
                    //         },
                    //     },
                    //     target: '.first-workspace-tour-step-17',
                    //     title: '',
                    // },
                    // {
                    //     content: "All your credit cards used for payments are here. 💳\n" +
                    //         +'Cards and payments are processed by Stripe.',
                    //     placement: 'left',
                    //     spotlightPadding: 0,
                    //     styles: {
                    //         options: {
                    //             zIndex: 10000,
                    //         },
                    //     },
                    //     target: '.first-workspace-tour-step-18',
                    //     title: '',
                    // },
                    // {
                    //     content: "Let's set-up your first Channel. 💪",
                    //     placement: 'right',
                    //     spotlightPadding: 0,
                    //     styles: {
                    //         options: {
                    //             zIndex: 10000,
                    //         },
                    //     },
                    //     target: '.first-workspace-tour-step-19',
                    //     title: '',
                    // },

                ]
            } else {
                steps = [

                    {
                        content: "Let's hop on a quick tour around the platform together!",
                        placement: 'center',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-1',
                        title: 'Congrats on creating your first workspace! 😎',
                    }, {
                        content: "Switch between your workspaces instantly from this dropdown menu.",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-2',
                        title: '',
                    }, {
                        content: <div>
                            <p>This will be your favorite place. 🤗</p>
                            <p>Start New Campaigns across all channels
                                here. To run campaigns you first need to enable and set-up all the channels you
                                want to use.</p>
                        </div>,

                        placement: 'right-bottom', spotlightPadding: 0, styles: {
                            options: {
                                zIndex: 10000,
                            },
                        }, target: '.first-workspace-tour-step-3', title: '',
                    },

                    {
                        content: "My Campaigns keep all your detailed analytics in one place.\n" + "It's the easiest way to compare your campaign performance across channels. Compare 🍏 and 🍏.",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-5',
                        title: '',
                    }, {
                        content: "Emitto has its own URL Shortener.\n" + "Short links make your posts look clean and give you the link-tracking superpower.\n" + "You can even add UTM Tags. 😎\n",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-6',
                        title: '',
                    }, {
                        content: "This is where you can find your FB Messenger and WebPush Subscribers.",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-7',
                        title: '',
                    }, {

                        content: "And here are all the Contacts waiting for SMS and Viber campaigns.",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-8',
                        title: '',
                    }, {
                        content: "Here you can enable and set-up all available Channels. 💬",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-9',
                        title: '',
                    }, {
                        content: "Want to use automatic RSS to WebPush notifications? Manage your content sources here.",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-10',
                        title: '',
                    }, {
                        content: "Tags are used to manage and segment your audience. You can use tags to create highly targeted campaigns. 🎯\n",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-11',
                        title: '',
                    }, {
                        content: "Need to rename your Workspace or Add Workspace Admins? Hop on to Workspace Settings.",
                        placement: 'right',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-12',
                        title: '',
                    },


                    {
                        content: "Profile settings and billing details are accessible from your account menu.",


                        placement: 'left', spotlightClicks: true, spotlightPadding: 0, styles: {
                            options: {
                                zIndex: 10000,
                            },
                        }, target: '.first-workspace-tour-step-13', title: '',
                    }, {
                        content: "These are your account settings. From here you can control your profile, payments and teams.\n" + "Let's hop on to billing!",
                        placement: 'left-top',
                        spotlightPadding: 0,
                        styles: {
                            options: {
                                zIndex: 10000,
                            },
                        },
                        target: '.first-workspace-tour-step-14',
                        title: '',
                    }, // {
                    //     content: "All your subscriptions, invoices and billing details are located here. 👉",
                    //     placement: 'left-top',
                    //     spotlightPadding: 0,
                    //     styles: {
                    //         options: {
                    //             zIndex: 10000,
                    //         },
                    //     },
                    //     target: '.first-workspace-tour-step-15',
                    //     title: '',
                    // },
                    // {
                    //     content: "Preview, download or print your Invoices from this section of your account.",
                    //     placement: 'left',
                    //     spotlightPadding: 0,
                    //     styles: {
                    //         options: {
                    //             zIndex: 10000,
                    //         },
                    //     },
                    //     target: '.first-workspace-tour-step-16',
                    //     title: '',
                    // },
                    // {
                    //     content: "If you find Emitto super valuable, you can easily upgrade your plan from here. 😉\n" +
                    //         "Also, here you can also find all your Subscriptions.",
                    //     placement: 'left',
                    //     spotlightPadding: 0,
                    //     styles: {
                    //         options: {
                    //             zIndex: 10000,
                    //         },
                    //     },
                    //     target: '.first-workspace-tour-step-17',
                    //     title: '',
                    // },
                    // {
                    //     content: "All your credit cards used for payments are here. 💳\n" +
                    //         +'Cards and payments are processed by Stripe.',
                    //     placement: 'left',
                    //     spotlightPadding: 0,
                    //     styles: {
                    //         options: {
                    //             zIndex: 10000,
                    //         },
                    //     },
                    //     target: '.first-workspace-tour-step-18',
                    //     title: '',
                    // },
                    // {
                    //     content: "Let's set-up your first Channel. 💪",
                    //     placement: 'right',
                    //     spotlightPadding: 0,
                    //     styles: {
                    //         options: {
                    //             zIndex: 10000,
                    //         },
                    //     },
                    //     target: '.first-workspace-tour-step-19',
                    //     title: '',
                    // },

                ]
            }

            if (this.props.location.state === 'subscription-done' && this.state.user.sources.data.length === 1 && window.innerWidth > 1023) {
                this.setState({
                    tourRun: true, steps, tourType: 2
                })
            }
        }

        if (this.state.user.sources.data.length > 0) {
            // console.log('cdm main.js - sources > 0')
            // console.log('main js state.user: ', this.state.user);
            // console.log('main js selectedSource: ', this.state.selectedSource);
            let selectedSourceFull = this.state.user.sources.data.filter(source => {
                return source.id.toString() === this.state.selectedSource.toString()
            })

            // if (selectedSourceFull.length === 0) {
            //     console.log('feeds_shared: ', this.state.user.feeds_shared);
            //     selectedSourceFull = this.state.user.feeds_shared.filter(source => {
            //         return source.project_id.toString() === this.state.selectedSource.toString()
            //     })
            // }

            //console.log('selectedSourceFull', selectedSourceFull);

            let currentPlan = selectedSourceFull.length && selectedSourceFull[0].plan ? selectedSourceFull[0].plan.plan_id : ''
            // console.log('1 cdm currentPlan: ', currentPlan)
            //console.log('2 cdm plansData: ', this.state.plansData);
            if (currentPlan.includes('martech')) {
                // console.log('current plan is martech')
                currentPlan = 'essentials_monthly'
            }

            let currentPlanLimitations = '';
            if (this.state.plansData) {
                //console.log('mainjs - cdm - plansDataExists')
                currentPlanLimitations = this.state.plansData.filter(plan => {
                    return plan.plan_id === currentPlan
                })
            }

            //console.log('MAIN.JS - cdm - currentPlanLimitations: ', currentPlanLimitations);
            let paymentResult = ''
            if (this.state.user && this.state.selectedSource) {
                try {
                    // console.log('payment result call entered')
                    paymentResult = await http.get('/api/user/' + this.state.user.id + '/project/' + this.state.selectedSource + '/customers/get_payment_methods_project', {headers: {authorization: getJwt()}});
                    //console.log('paymentResult: ', paymentResult)
                } catch (e) {
                    //console.log('app.js get payments error: ', e)
                    toastr.error('Something went wrong, please refresh and try again')
                }
            }
            let platformsEnabled = selectedSourceFull[0] ? selectedSourceFull[0].platforms_enabled : ''


            //
            // let projectBalance = selectedSourceFull[0] && selectedSourceFull[0].project_balance !== null ?
            //     Number(this.state.selectedSourceFull[0].project_balance.balance_cents / 100).toFixed(2) : ''
            //
            // let viberBalance = selectedSourceFull[0] && selectedSourceFull[0].viber_client !== null ?
            //     selectedSourceFull[0].viber_client.available_credit.slice(-1) === '$' ?
            //         Number(selectedSourceFull[0].viber_client.available_credit.slice(0, -1)).toFixed(2) :
            //         Number(selectedSourceFull[0].viber_client.available_credit).toFixed(2) : this.state.viberBalance

            //console.log('main.js - cdm - selectSourceFull: ', selectedSourceFull)
            await this.setState({
                currentPlan,
                currentPlanLimitations,
                selectedSource: this.state.selectedSource,
                selectedSourceFull,
                projectPaymentMethod: paymentResult !== '' ? paymentResult.data.project_payment_methods[0] : '',
                platformsEnabled, // projectBalance,
                // viberBalance
            });

        }

        let project;

        // console.log('MAIN.JS stripe plans: ', result)
        // console.log('MAIN.JS selectedSource: ', parseInt(this.state.selectedSource))
        // console.log('MAIN.JS sources array: ', this.state.user.sources.data)


        // project = await this.state.user.sources.data.filter(project => project.id === parseInt(this.state.selectedSource));
        //
        // await this.setState({
        //     selectedSourceFull: project
        // })

        window.addEventListener('resize', this.menuFixer)
        this.analytics();

        const user_id = getCurrentUserId();

        if (!user_id && (window.location.pathname !== "/login" && window.location.pathname !== "/register")) {
            window.location = "/login";
        }

    }

    componentDidUpdate = async () => {
        // console.log('main.js CDU parameters-> ')
        // console.log('prevProps: ', prevProps)
        // console.log('prevState: ', prevState)
        // console.log('snapshot: ', snapshot)

        if (this.state.user !== this.props.user) {
            // console.info('user changed')

            let user = this.props.user

            if (user.sources.data.length > 0) {
                // console.log('new selectedSourceFull')
                // console.log('cdm main.js - sources > 0')
                // console.log('main js state.user: ', this.state.user);
                // console.log('main js selectedSource: ', this.state.selectedSource);
                let selectedSourceFull = user.sources.data.filter(source => {
                    return source.id.toString() === this.state.selectedSource.toString()
                })
                // console.log('main.js - cdu - selectedSourceFull: ', selectedSourceFull)

                // let projectBalance = selectedSourceFull[0] && selectedSourceFull[0].project_balance !== null ?
                //     Number(this.state.selectedSourceFull[0].project_balance.balance_cents / 100).toFixed(2) : ''
                //
                // let viberBalance = selectedSourceFull[0] && selectedSourceFull[0].viber_client !== null ?
                //     selectedSourceFull[0].viber_client.available_credit.slice(-1) === '$' ?
                //         Number(selectedSourceFull[0].viber_client.available_credit.slice(0, -1)).toFixed(2) :
                //         Number(selectedSourceFull[0].viber_client.available_credit).toFixed(2) : this.state.viberBalance
                //

                this.setState({
                    //projectBalance,
                    // viberBalance,
                    selectedSourceFull
                })

            }


            this.setState({user});


        }
        if (this.state.selectedSource !== this.props.selectedSource) {
            // console.log('cwrp user: ', this.state.user)
            // console.log('this.props.selectedSource: ', this.props.selectedSource || 'nema 1', this.state.selectedSource || 'nema 2');
            // console.log('state plans date: ', this.state.plansData);
            this.setState({selectedSource: this.props.selectedSource});
            if (this.state.plansData) {
                if (this.props.user.sources.data.length > 0) {
                    let selectedSourceFull = this.props.user.sources.data.filter(source => {
                        return source.id.toString() === this.props.selectedSource
                    })
                    // if (selectedSourceFull.length === 0) {
                    //     //console.log('this.props.user.feeds_shared: ', this.props.user.feeds_shared);
                    //     selectedSourceFull = this.props.user.feeds_shared.filter(source => {
                    //         return source.project_id.toString() === this.props.selectedSource.toString()
                    //     })
                    // }
                    //console.log('main js - cwrp - selectedSourceFull: ', selectedSourceFull);
                    let platformsEnabled = selectedSourceFull[0] ? selectedSourceFull[0].platforms_enabled : ''
                    let currentPlan = selectedSourceFull.length && selectedSourceFull[0].plan ? selectedSourceFull[0].plan.plan_id : ''
                    // console.log('1 cwrp currentPlan: ', currentPlan)
                    // console.log('2 cwrp plansData: ', this.state.plansData);

                    if (currentPlan.includes('martech')) {
                        currentPlan = 'essentials_monthly'
                    }

                    let currentPlanLimitations = this.state.plansData.filter(plan => {
                        return plan.plan_id === currentPlan
                    })


                    let paymentResult = ''
                    try {
                        paymentResult = await http.get('/api/user/' + this.state.user.id + '/project/' + this.props.selectedSource + '/customers/get_payment_methods_project', {headers: {authorization: getJwt()}});
                        //console.log('paymentResult: ', paymentResult)
                    } catch (e) {
                        //console.log('app.js get payments error: ', e)
                        toastr.error('Something went wrong, please refresh and try again')
                    }
                    //console.log('main.js - cwrp - selectSourceFull: ', selectedSourceFull)


                    // console.log('main.js - cwrp - currentPlan', currentPlan);
                    // console.log('main.js - cwrp - currentPlanLimitations: ', currentPlanLimitations);


                    await this.setState({
                        currentPlan,
                        currentPlanLimitations: currentPlanLimitations,
                        selectedSourceFull,
                        projectPaymentMethod: paymentResult.data.project_payment_methods[0],
                        platformsEnabled
                    });
                }
            }
        }

        if (this.state.plansData !== this.props.plansData) {
            //console.log('plans data different')
            let selectedSourceFull = this.props.user.sources.data.filter(source => {
                return source.id.toString() === this.props.selectedSource.toString()
            })
            let currentPlan = selectedSourceFull.length && selectedSourceFull[0].plan ? selectedSourceFull[0].plan.plan_id : ''

            if (currentPlan.includes('martech')) {
                currentPlan = 'essentials_monthly'
            }

            // console.log('1 cwrp currentPlan: ', currentPlan)
            // console.log('2 cwrp plansData: ', this.state.plansData);
            let currentPlanLimitations = '';
            if (this.props.plansData) {
                currentPlanLimitations = this.props.plansData.filter(plan => {
                    return plan.plan_id === currentPlan
                })
            }
            //console.log('MAIN.JS - cdu - current plan limitations: ', currentPlanLimitations)

            await this.setState({
                plansData: this.props.plansData, //currentPlanLimitations
            })
        }

    }


    toggleMenu = () => {
        const menu = document.querySelector('#profile-menu-dropdown');
        if (this.state.firstLoad === true) {
            this.setState({fistLoad: false})
        }
        if (this.state.menuActive) {
            this.setState({
                menuActive: false
            });
            menu.classList.add('inactive');
            setTimeout(function () {
                menu.classList.add('d-none')
            }, 300);
            //console.log('menu closed:', menu)

        } else {
            setTimeout(() => {
                this.setState({menuActive: true});
                //console.log('menu opened:', menu)

            }, 1);


        }

    };

    handleCloseSuccessCallout = () => {
        localStorage.setItem('doNotShowSuccessCallout', true);
        this.props.updateUserFromServer()
        // console.log('doNotShowSuccessCallout: ', JSON.parse(localStorage.getItem('doNotShowSuccessCallout')));
    }

    handleAccountVerificationRejectedRedirect = () => {
        let selected_source = this.props.appState.selected_source;
        let selected_source_node = '';

        if (this.props.appState.selected_source) {
            selected_source_node = this.props.appState.user.sources.data.filter(source => source.id.toString() === selected_source.toString())[0];
        }
        let verif = selected_source_node && selected_source_node.business_verification ? selected_source_node.business_verification : ''
        if (verif) {
            if (verif.type === 'individual') {
                this.props.history.push('/account-verification/personal-details')
            } else if (verif.type === 'business') {
                if (!verif.business_address.basic_info_valid || (!verif.documentation || !verif.documentation.documentation_info_valid)) {
                    this.props.history.push('/account-verification/business-details')
                } else if (verif.business_address.basic_info_valid && verif.documentation && verif.documentation.documentation_info_valid) {
                    this.props.history.push('/account-verification/authorized-representative-details')
                }
            } else if (verif.type === 'business4business') {
                if (!verif.business_address.basic_info_valid || (!verif.documentation || !verif.documentation.documentation_info_valid)) {
                    this.props.history.push('/account-verification/business-details')
                } else if (!verif.authorised_representative || !verif.authorised_representative.representative_info_valid) {
                    this.props.history.push('/account-verification/authorized-representative-details')
                } else if (!verif.client_business || !verif.client_business.cb_basic_info_valid) {
                    this.props.history.push('/account-verification/client-business-details')
                } else if (!verif.client_business || !verif.client_business.cb_representative_info_valid) {
                    this.props.history.push('/account-verification/client-contact-person-details')
                }
            }
        } else {
            toastr.error('Error, please reload this page')
        }

    }

    render() {
        const {
            closeModal,
            closeModalActive,
            openModal,
            acceptModal,
            addSource,
            activateFeed,
            deleteFeed,
            openModalDeleteFeed,
            enablePlatform,
            addCard,
            checkAllPagesAndChannels,
            checkPagesAndChannels,
            onClickHam,
            onSourceSwitch,
            updateSources,
            validateRss,
            updatePhoto,
            toggleFeedInfo,
            selectFeed,
            toggleConnect,
            updateUser,
            appPropagateTeams,
            selectSource
        } = this.props;

        //joyride constants
        const {tourRun, steps, stepIndex} = this.state;

        // const { name, email, profile_photo, feeds_shared, facebook_pages_shared } = this.state.user;
        const {user, name, email} = this.props.appState;
        //const feeds_shared = this.props.appState.user.feeds_shared;
        const {
            checked_send_all,
            checked_channels,
            team_name,
            team_id,
            admin_id,
            checked_sources,
            rss_valid,
            team_added,
            teams,
            teams_in,
            admin_in_team
        } = this.props.appState;
        // console.info('teams: ', teams)
        // console.info('teams_in: ', teams_in)
        const {
            visible_edit_tag_modal,
            visible_delete_tag_modal,
            visible_tags_modal,
            visible_email_modal,
            visible_password_modal,
            visible_team_modal,
            visible_team_edit_modal,
            visible_team_modal_admins,
            visible_invite_admins_modal,
            visible_delete_team_modal,
            visible_post_reach_modal,
            visible_connect_bot_to_page_modal,
            visible_delete_feed_modal,
            feed_id,
            remove_activation_email_modal,
            visible_reassign_feed_modal,
            visible_feed_info_edit_modal,
            visible_rss_delete_modal,
            visible_web_push_instructions_modal,
            visible_facebook_video_modal,
            visible_webpush_video_modal,
            visible_overview_video_modal,
            visible_contact_support_modal,
            visible_connect_viber_modal,
            reassign_feed_name,
            visible_delete_subscribers_modal
        } = this.props.appState;
        const {facebook_pages_shared, profile_photo} = this.props.appState.user;

        let {active} = this.props.appState;
        const sources = this.props.appState.user.sources.data;
        // console.log("MAIN MAIN this.state.user ", this.props.appState.user);

        const user_facebook_pages = this.props.appState.user.facebook_pages.data;
        // console.log("MAIN MAIN user_facebook_pages ", user_facebook_pages);

        let selected_source = this.props.appState.selected_source;
        let selected_source_node = '';

        if (sources) {
            selected_source_node = sources.filter(source => source.id.toString() === selected_source.toString())[0];
        }

        let isFreePlan = selected_source_node && selected_source_node.plan && selected_source_node.plan.plan_id === 'free_plan';
        let isInactivePlan = selected_source_node && selected_source_node.plan && selected_source_node.plan.plan_id === 'inactive';
        let notVisibleOnFreePlan = (pathname) => {
            // console.log('notVisibleOnFreePlan: ', pathname)
            if (isFreePlan && pathname !== "/free-plan" && pathname !== "/edit-profile" && pathname !== "/edit-profile/personal-info" && pathname !== "/edit-profile/security" && pathname !== "/edit-profile/date-time" && pathname !== "/billing" && pathname !== "/billing/balance" && pathname !== "/billing/invoices" && pathname !== "/billing/subscriptions" && pathname !== "/billing/payment-methods" && pathname !== "/teams" && pathname !== "/workspace-settings") {
                return true
            } else {
                return false
            }
        }
        let notVisibleOnInactivePlan = (pathname) => {
            // console.log('notVisibleOnFreePlan: ', pathname)
            if (isInactivePlan && pathname !== "/free-plan" && pathname !== "/edit-profile" && pathname !== "/edit-profile/personal-info" && pathname !== "/edit-profile/security" && pathname !== "/edit-profile/date-time" && pathname !== "/billing" && pathname !== "/billing/balance" && pathname !== "/billing/invoices" && pathname !== "/billing/subscriptions" && pathname !== "/billing/payment-methods" && pathname !== "/teams" && pathname !== "/workspace-settings") {
                return true
            } else {
                return false
            }
        }


        // For testing all business_verification cases (success, in-review, rejected, null)
        // Business verification related changes has to be changed also in TopHeader.js
        // selected_source_node = {
        //     ...selected_source_node,
        //     business_verification: selected_source_node && selected_source_node.business_verification ?
        //         {
        //             ...selected_source_node.business_verification,
        //             status: 'verified'
        //         }
        //         :
        //         {
        //             status: 'verified'
        //         }
        // }
        // if (!selected_source_node
        //     && feeds_shared && selected_source) {
        //     selected_source_node = feeds_shared.filter(source =>
        //         source.project_id && source.project_id.toString() === selected_source.toString())[0];
        // }

        //console.log('selected_source_node: ', selected_source_node);
        // console.log("MAIN MAIN   ---    selected_source ", selected_source);
        let selected_source_rss = this.props.appState.selected_source_rss;
        let source_active = this.props.appState.source_active;
        let platforms_enabled = this.props.appState.platforms_enabled;

        let thisSource = "";
        if (sources) {
            thisSource = sources.filter(thisSource => thisSource.id.toString() === selected_source.toString())[0];
        }
        // if (!thisSource && feeds_shared && selected_source) {
        //     thisSource = feeds_shared.filter(thisSource =>
        //         thisSource.project_id && thisSource.project_id.toString() === selected_source.toString())[0];
        // }


        if (!active && remove_activation_email_modal) {
            active = true;
        }
        let modal_tags = <CreateTagModal visible_modal={visible_tags_modal}
                                         closeModal={closeModal}
                                         acceptModal={acceptModal}
        />;
        let modal_edit_tag = <TagModal visible_modal={visible_edit_tag_modal}
                                       closeModal={closeModal}
                                       acceptModal={acceptModal}
                                       tagId={this.props.tagId}
                                       tagName={this.props.tagName}

        />;

        let modal_delete_tag = <DeleteTagModal
            visible_modal={visible_delete_tag_modal}
            tagId={this.props.tagId}
            tagName={this.props.tagName}
            onClickAway={closeModal}
            acceptModal={acceptModal}
        />;
        let modal_email = <EmailModal visible_modal={visible_email_modal}
                                      onClickAway={closeModal}
                                      acceptModal={acceptModal}
                                      email={email}/>;


        let modal_password = <PasswordModal visible_modal={visible_password_modal}
                                            onClickAway={closeModal}
                                            acceptModal={acceptModal}/>;

        let modal_post_reach = <PostReachModal
            fbError={this.props.fbError}
            fb_sent={this.props.fb_sent}
            loadingPostReach={this.state.loadingPostReach}
            history={this.props.history}
            visible_modal={visible_post_reach_modal}
            onClickAway={closeModal}
            post_reach_subscribers_count={this.props.appState.post_reach_subscribers_count}
            postStats={this.props.appState.postStats}
            count_push_subscrib={this.props.appState.count_push_subscrib}
            count_fb_subscrib={this.props.appState.count_fb_subscrib}
            count_not_sent={this.props.appState.count_not_sent}
            count_total_subscrib_sent={this.props.appState.count_total_subscrib_sent}
        />;


        let modal_team = <TeamModal visible_modal={visible_team_modal}
                                    onClickAway={closeModal}
                                    acceptModal={acceptModal}
                                    team_name=""/>;

        let modal_team_edit = <EditTeamModal visible_modal={visible_team_edit_modal}
                                             onClickAway={closeModal}
                                             acceptModal={acceptModal}
                                             team_name={team_name}
                                             team_id={team_id}/>;

        let modal_team_admins = <AddAdminsTeamModal visible_modal={visible_team_modal_admins}
                                                    onClickAway={closeModal}
                                                    acceptModal={acceptModal}
                                                    team_name={team_name}
                                                    email={email}
                                                    sources={sources}
                                                    team_id={team_id}
                                                    checked_sources={checked_sources}
                                                    checkPagesAndChannels={checkPagesAndChannels}/>;

        let modal_invite_admins = <InviteAdminsFeedModal visible_modal={visible_invite_admins_modal}
                                                         onClickAway={closeModal}
                                                         acceptModal={acceptModal}
                                                         team_name={team_name}
                                                         email={email}
                                                         textTopMsg="Invite admins to feed: "
                                                         grantPrivilegesMsg="Grant admin privileges for this feed"
                                                         team_id={team_id}/>;

        let modal_team_delete = <DeleteTeamModal visible_modal={visible_delete_team_modal}
                                                 onClickAway={closeModal}
                                                 acceptModal={acceptModal}
                                                 team_name={team_name}
                                                 team_id={team_id}
                                                 admin_id={admin_id}
                                                 team_admin={admin_in_team ? "team admin" : team_name}/>;
        let modal_activation = <ActivationModal visible_modal={!active}
                                                onClickAway={closeModalActive}
                                                acceptModal={acceptModal}
                                                email={email}/>;

        let modal_connect_bot_to_page = <ConnectBotToPageModal visible_modal={visible_connect_bot_to_page_modal}
                                                               onClickAway={closeModal}
                                                               toggleConnect={toggleConnect}
                                                               page_name={this.state.target_page_to_connect.slot}
                                                               sources={sources}
            //feeds_shared={feeds_shared}
                                                               selectedSource={selected_source}/>;

        let modal_feed_delete = <DeleteFeedModal visible_modal={visible_delete_feed_modal}
                                                 onClickAway={closeModal}
                                                 acceptModal={deleteFeed}
                                                 feed_id={feed_id}
                                                 admin_id={admin_id}
                                                 feed_name={selected_source_node ? selected_source_node.name : ''}/>;

        let modal_feed_reassign = <ReassignFeedModal visible_modal={visible_reassign_feed_modal}
                                                     onClickAway={closeModal}
                                                     acceptModal={acceptModal}
                                                     feed_id={feed_id}
                                                     team_id={team_id}
                                                     teams={teams}
                                                     teams_in={teams_in}
                                                     feed_name={reassign_feed_name}/>;

        let modal_feed_info_edit = <FeedInfoEditModal visible_modal={visible_feed_info_edit_modal}
                                                      acceptModal={acceptModal}
                                                      onClickAway={closeModal}
                                                      feed_id={feed_id}
        />

        let modal_delete_rss = <DeleteRssModal visible_modal={visible_rss_delete_modal}
                                               acceptModal={acceptModal}
                                               onClickAway={closeModal}
                                               rss_feed={selected_source_rss}
                                               thisSource={thisSource}/>
        let delete_subscribers_modal = <DeleteSubscribersModal visible_modal={visible_delete_subscribers_modal}
                                                               acceptModal={acceptModal}
                                                               onClickAway={closeModal}
                                                               deleteSubscribersIds={this.props.deleteSubscribersIds}
                                                               deleteSubscribersType={this.props.deleteSubscribersType}
        />

        let modal_connect_viber = <ConnectViberModal
            visible_modal={visible_connect_viber_modal}
            selectedSource={selected_source}
            sources={sources}
            acceptModal={this.acceptModal}
            onClickAway={this.closeModal}
        />

        let modal_facebook_video = <FacebookVideoModal
            onClickAway={closeModal}

        />
        let modal_webpush_video = <WebpushVideoModal
            onClickAway={closeModal}

        />
        let modal_overview_video = <OverviewVideoModal
            onClickAway={closeModal}

        />

        let modal_contact_support = <ContactSupportModal
            name={name} email={email}
            visible_modal={visible_contact_support_modal}
            onClickAway={closeModal}
            acceptModal={acceptModal}
            team_name=""
        />;

        //console.log("MAIN MAIN rss_valid ", rss_valid);
        // console.log('MAIN JS user: ', user)
        // console.log('MAIN JS selected_source:', selected_source)
        // console.log('MAIN JS selected_source_full:', this.state.selectedSourceFull)


        const workspaces = {}
        const userSources = this.state.user.sources.data

        userSources.map(source => {
            //console.log('source: ', source)
            workspaces[source.name] = source && source.plan && source.plan.name ? source.plan.name : ''
        })
        // console.log('workspaces: ', workspaces)

        let trial = false

        this.state.user.sources.data.map(source => {
            // console.log('source.name: ', source.name)
            if (source && source.plan && source.plan.free_trial && source.plan.free_trial !== '0') {
                trial = true
            }
        })

        const businessVerification = !this.state.selectedSourceFull[0] ? 'N/A' : this.state.selectedSourceFull[0].business_verification ? this.state.selectedSourceFull[0].business_verification.status ? this.state.selectedSourceFull[0].business_verification.status === 'verified' ? 'Verified' : this.state.selectedSourceFull[0].business_verification.status === 'in-review' ? 'In-Review' : this.state.selectedSourceFull[0].business_verification.status === 'rejected' ? 'Rejected' : '' : '' : ''
        //console.log('businessVerification:', businessVerification)
        const intercomUser = {
            user_id: user.id,
            email: user.email,
            name: user.first_name + ' ' + user.last_name,
            created_at: user.created_at,
            subscription_interval: this.state.selectedSourceFull[0] ? this.state.selectedSourceFull[0].plan ? this.state.selectedSourceFull[0].plan.plan_id ? this.state.selectedSourceFull[0].plan.plan_id.includes('yearly') ? 'yearly' : this.state.selectedSourceFull[0].plan.plan_id.includes('martech') ? 'LTD' : 'monthly' : '' : '' : '',
            plan_type: this.state.selectedSourceFull[0] ? this.state.selectedSourceFull[0].plan ? this.state.selectedSourceFull[0].plan.name ? this.state.selectedSourceFull[0].plan.name : '' : '' : '',
            company_name: user.organisation,
            phone: user.phone,
            country: user.country_name,
            state: user.state,
            project_name: this.state.selectedSourceFull[0] ? this.state.selectedSourceFull[0].name : '',
            credit_card_expiration: this.state.projectPaymentMethod && this.state.projectPaymentMethod.ends_at ? this.state.projectPaymentMethod.ends_at : '',
            workspaces: workspaces,
            trial: trial,
            customer: "https://emitto.chargebee.com/d/customers/" + this.state.user.customer,
            user_type: this.state.user.user_type,
            suspended: this.state.user.suspended === 1,
            business_verification: businessVerification

        };

        let doNotShowSuccessCallout = JSON.parse(localStorage.getItem('doNotShowSuccessCallout'));


        //console.log('intercomUser: ', intercomUser)
        return (<React.Fragment>

            <div>

                {visible_email_modal ? modal_email : ""}
                {visible_delete_tag_modal ? modal_delete_tag : ""}
                {visible_edit_tag_modal ? modal_edit_tag : ""}
                {visible_tags_modal ? modal_tags : ""}
                {visible_password_modal ? modal_password : ""}
                {visible_team_modal ? modal_team : ""}
                {visible_team_edit_modal ? modal_team_edit : ""}
                {visible_team_modal_admins ? modal_team_admins : ""}
                {visible_invite_admins_modal ? modal_invite_admins : ""}
                {visible_delete_team_modal ? modal_team_delete : ""}
                {visible_post_reach_modal ? modal_post_reach : ""}
                {visible_connect_bot_to_page_modal ? modal_connect_bot_to_page : ""}
                {(typeof (active) !== 'undefined') && !active ? modal_activation : ""}
                {visible_delete_feed_modal ? modal_feed_delete : ""}
                {visible_reassign_feed_modal ? modal_feed_reassign : ""}
                {visible_feed_info_edit_modal ? modal_feed_info_edit : ""}
                {visible_rss_delete_modal ? modal_delete_rss : ""}
                {visible_facebook_video_modal ? modal_facebook_video : ""}
                {visible_webpush_video_modal ? modal_webpush_video : ""}
                {visible_overview_video_modal ? modal_overview_video : ""}
                {visible_contact_support_modal ? modal_contact_support : ""}
                {visible_connect_viber_modal ? modal_connect_viber : ""}
                {visible_delete_subscribers_modal ? delete_subscribers_modal : ""}

                {(selected_source_node && selected_source_node.business_verification && selected_source_node.business_verification.status && selected_source_node.business_verification.status === 'verified' && doNotShowSuccessCallout) || !selected_source_node ? '' :
                    <div className='top-header-callout-container'/>}

                {selected_source_node && selected_source_node.business_verification && selected_source_node.business_verification.status ? selected_source_node.business_verification.status === 'verified' ? doNotShowSuccessCallout ? '' :
                    <div
                        className='top-header-callout success'
                    >
                        <i onClick={this.handleCloseSuccessCallout} className="fas fa-times"></i>
                        <p className='text-align-center margin-bottom-0'>Great news! Your business was
                            successfully verified! Now you're free to use Emitto to the fullest!</p>
                    </div> : selected_source_node.business_verification.status === 'in-review' ? <div
                    className='top-header-callout warning'
                >
                    <p className='text-align-center margin-bottom-0'>Thank you for submitting your
                        business data.
                        The verification process can take up to 72 hours. Until then you can use Emitto
                        with limited capabilities.</p>
                </div> : selected_source_node.business_verification.status === 'rejected' ? <div
                    className='top-header-callout danger'
                >
                    <p className='text-align-center margin-bottom-0'>
                        Additional information is required in order to validate your account. <a
                        onClick={this.handleAccountVerificationRejectedRedirect}
                    >Please follow this link to continue the process</a>.
                    </p>
                </div> : <div
                    className='top-header-callout danger'
                >
                    <p className='text-align-center margin-bottom-0'>In order to take advantage of
                        all Emitto features,
                        you need to <a
                            onClick={() => this.props.history.push('/account-verification/select-type')}>verify
                            your business account first.</a></p>
                </div> : selected_source_node ? <div
                    className='top-header-callout danger'
                >
                    <p className='text-align-center margin-bottom-0'>In order to take advantage of all
                        Emitto
                        features,
                        you need to <a
                            onClick={() => this.props.history.push('/account-verification/select-type')}>verify
                            your
                            business account first.</a></p>
                </div> : ''}

                <div
                    className={(visible_delete_tag_modal || visible_tags_modal || visible_email_modal || visible_password_modal || visible_team_modal || visible_team_edit_modal || visible_connect_bot_to_page_modal || visible_team_modal_admins || visible_invite_admins_modal || visible_delete_team_modal || visible_post_reach_modal || visible_delete_feed_modal || visible_reassign_feed_modal || visible_feed_info_edit_modal || visible_rss_delete_modal || visible_web_push_instructions_modal || visible_facebook_video_modal || visible_webpush_video_modal || visible_overview_video_modal || visible_contact_support_modal || visible_connect_viber_modal || visible_delete_subscribers_modal || ((typeof (active) !== 'undefined') && !active)) ? "blur wrapper" : "wrapper"}
                >
                    <Navigation {...this.props}
                                onClickHam={onClickHam}
                                sources={sources}
                                selectedSource={selected_source}
                                selectedSourceName={selected_source_node ? selected_source_node.name : ''}
                                selected_source_rss={selected_source_rss}
                                openModal={openModal}
                        //feeds_shared={feeds_shared}
                                addSource={this.addSource}
                                onClick={onSourceSwitch}
                                checkIfProjectPlanSelected={this.props.checkIfProjectPlanSelected}
                                subscription_renewal_problem={this.props.subscription_renewal_problem || (selected_source_node && selected_source_node.name === 'Greska')}
                                isShowingTopHeaderCallout={selected_source_node && selected_source_node.business_verification && selected_source_node.business_verification.status ? selected_source_node.business_verification.status === 'verified' ? doNotShowSuccessCallout ? false : true : true : selected_source_node ? true : false}
                    />
                    <Joyride
                        callback={this.handleJoyrideCallback}
                        continuous={true}
                        getHelpers={this.getHelpers}
                        run={tourRun}
                        disableScrollParentFix={true}
                        scrollToFirstStep={true}
                        showProgress={true}
                        showSkipButton={true}
                        steps={steps}
                        styles={{
                            options: {
                                zIndex: 10000, primaryColor: '#26AAE1'
                            },
                        }}
                    />
                    <div className='onboarding-tour-step-1'>
                        <TopHeader
                            firstLoad={this.state.firstLoad}
                            menuActive={this.state.menuActive}
                            toggleMenu={this.toggleMenu}
                            user_name={name}
                            sources={sources}
                            //feeds_shared={feeds_shared}
                            profile_photo={profile_photo}
                            selectedSource={selected_source}
                            selectedSourceNode={selected_source_node}
                            selected_source_rss={selected_source_rss}
                            source_active={source_active}
                            onClick={onSourceSwitch}
                            user={this.state.user}
                            onClickHam={onClickHam}

                            // passedTop={this.state.passedTop}
                            // show={this.state.show}
                            // scrollPos={this.state.scrollPos}

                            activateFeed={activateFeed}
                            doNotShowSuccessCallout={doNotShowSuccessCallout}
                            openProfileFromMain={this.state.openProfileFromMain}
                        />
                    </div>
                    <div
                        className={window.location.href.indexOf("sms-inbox") > -1 ? 'main-content sms-inbox-main first-workspace-tour-step-1' : 'main-content first-workspace-tour-step-1'}>
                        {this.props.subscription_renewal_problem || (selected_source_node && selected_source_node.name === 'Greska') ?
                            <div className='subscription-problem-red'>
                                <p>Problem with your subscription charge. <span>Check your payment methods</span>
                                </p>
                            </div> : ''}
                        <main
                            className={window.location.href.indexOf("sms-inbox") > -1 ? 'sms-inbox-main' : ''}
                        >
                            {!this.state.user.sources.data.length ? <NoFeeds
                                userFullName={this.state.user.first_name + ' ' + this.state.user.last_name}
                            /> : <Switch>
                                <Route path="/free-plan"
                                       render={(props) => <FreePlanPreview
                                           name={user.first_name}
                                           {...props}
                                       />}
                                />
                                {/*{ isFreePlan && window.location.pathname !== "/free-plan" && window.location.pathname !== "/edit-profile/personal-info" &&*/}
                                {/*window.location.pathname !== "/edit-profile/security" && window.location.pathname !== "/edit-profile/date-time" ?*/}
                                {/*    console.log('Yup')*/}
                                {/*    :*/}
                                {/*    console.log('nope: ', )*/}
                                {/*}*/}
                                {/*{ isFreePlan && window.location.pathname !== "/free-plan" && window.location.pathname !== "/edit-profile/personal-info" &&*/}
                                {/*window.location.pathname !== "/edit-profile/security" && window.location.pathname !== "/edit-profile/date-time" ?*/}
                                {/*    <Redirect to="/free-plan" />*/}
                                {/*    :*/}
                                {/*    ''*/}
                                {/*}*/}
                                <Route path="/dashboard"
                                       render={(props) => notVisibleOnFreePlan(props.location.pathname) ?
                                           <FreePlanPreview
                                               name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                               <InactivePlanPreview userId={user.id}
                                                                    selectedSourceNode={selected_source_node}{...props}/> :
                                               <Dashboard
                                                   loadingSource={this.props.loadingSource}
                                                   loadingSourceChange={this.props.loadingSourceChange}
                                                   sources={sources}
                                                   //feeds_shared={feeds_shared}
                                                   selectedSource={selected_source}
                                                   checkAllPagesAndChannels={checkAllPagesAndChannels}
                                                   checkPagesAndChannels={checkPagesAndChannels}
                                                   checked_send_all={checked_send_all}
                                                   checked_channels={checked_channels}
                                                   addSource={this.addSource}
                                                   userFullName={localStorage.user_name}
                                                   checkIfProjectPlanSelected={this.props.checkIfProjectPlanSelected}
                                                   {...props}
                                               />}
                                />
                                {/*{process.env.REACT_APP_ENVIRONMENT === 'DEV' ?*/}
                                {/*    <Route path="/dashboard"*/}
                                {/*           render={(props) => <Dashboard*/}
                                {/*               loadingSource={this.props.loadingSource}*/}
                                {/*               loadingSourceChange={this.props.loadingSourceChange}*/}
                                {/*               sources={sources}*/}
                                {/*               //feeds_shared={feeds_shared}*/}
                                {/*               selectedSource={selected_source}*/}
                                {/*               checkAllPagesAndChannels={checkAllPagesAndChannels}*/}
                                {/*               checkPagesAndChannels={checkPagesAndChannels}*/}
                                {/*               checked_send_all={checked_send_all}*/}
                                {/*               checked_channels={checked_channels}*/}
                                {/*               addSource={this.addSource}*/}
                                {/*               userFullName={localStorage.user_name}*/}
                                {/*               checkIfProjectPlanSelected={this.props.checkIfProjectPlanSelected}*/}
                                {/*               {...props}*/}
                                {/*           />*/}
                                {/*           }*/}
                                {/*    />*/}
                                {/*    : ''}*/}

                                <Route path="/new"
                                       render={(props) => notVisibleOnFreePlan(props.location.pathname) ?
                                           <FreePlanPreview
                                               name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                               <InactivePlanPreview userId={user.id}
                                                                    selectedSourceNode={selected_source_node}{...props}/> :
                                               <Campaigns
                                                   {...props}
                                                   user={user}
                                                   selectedSource={selected_source}
                                                   selectedSourceNode={selected_source_node}
                                                   sources={sources}
                                                   // feeds_shared={feeds_shared}
                                                   updateUser={updateUser}
                                                   user_facebook_pages={user_facebook_pages}
                                                   facebook_pages_shared={facebook_pages_shared}
                                                   platforms_enabled={platforms_enabled}
                                                   appPropagateUserData={this.props.appPropagateUserData}
                                                   updateUserFromServer={this.props.updateUserFromServer}
                                                   currentPlanLimitations={this.state.currentPlanLimitations}
                                                   tags={this.props.tags}
                                                   plansData={this.props.plansData}
                                                   loadingSubscribers={this.loadingSubscribers}
                                                   checkAllPagesAndChannels={checkAllPagesAndChannels}
                                                   checkPagesAndChannels={checkPagesAndChannels}
                                                   checked_send_all={checked_send_all}
                                                   checked_channels={checked_channels}
                                                   addSource={this.addSource}
                                                   openModal={openModal}
                                                   userFullName={getCurrentUserName()}
                                                   visible_post_reach_modal={visible_post_reach_modal}
                                                   filterTags={this.props.filterTags}

                                               />}
                                />


                                <ProtectedRoute path="/subscribers"
                                                render={(props) => notVisibleOnFreePlan(props.location.pathname) ?
                                                    <FreePlanPreview
                                                        name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                                        <InactivePlanPreview userId={user.id}
                                                                             selectedSourceNode={selected_source_node}{...props}/> :
                                                        <Subscribers
                                                            loadingSource={this.props.loadingSource}
                                                            loadingSourceChange={this.props.loadingSourceChange}
                                                            tags={this.props.tags}
                                                            filteredTags={this.props.filteredTags}
                                                            sources={sources}
                                                            selected_source={selected_source}
                                                            openModal={openModal}
                                                            addSource={this.addSource}
                                                            userFullName={getCurrentUserName()}
                                                            handleGetTags={this.props.handleGetTags}
                                                            handleCreateTag={this.props.handleCreateTag}
                                                            tagsOnlyNames={this.props.tagsOnlyNames}
                                                            updateUserFromServer={this.props.updateUserFromServer}
                                                            deleteSubscribersIndicator={this.props.deleteSubscribersIndicator}
                                                            setDeleteSubscribersIndicator={this.props.setDeleteSubscribersIndicator}
                                                            isodateToDate={this.props.isodateToDate}
                                                            {...props}/>}/>


                                <Route path="/facebook-message"
                                       render={(props) => notVisibleOnFreePlan(props.location.pathname) ?
                                           <FreePlanPreview
                                               name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                               <InactivePlanPreview userId={user.id}
                                                                    selectedSourceNode={selected_source_node}{...props}/> :
                                               <FacebookMessageCustomPost
                                                   visible_post_reach_modal={visible_post_reach_modal}
                                                   tags={this.props.tags}
                                                   filterTags={this.props.filterTags}
                                                   loadingSubscribers={this.loadingSubscribers}
                                                   sources={sources}
                                                   //feeds_shared={feeds_shared}
                                                   selectedSource={selected_source}
                                                   checkAllPagesAndChannels={checkAllPagesAndChannels}
                                                   checkPagesAndChannels={checkPagesAndChannels}
                                                   checked_send_all={checked_send_all}
                                                   checked_channels={checked_channels}
                                                   addSource={this.addSource}
                                                   openModal={openModal}
                                                   user_facebook_pages={user_facebook_pages}
                                                   facebook_pages_shared={facebook_pages_shared}
                                                   platforms_enabled={platforms_enabled}
                                                   userFullName={getCurrentUserName()}
                                                   user={user}
                                                   currentPlanLimitations={this.state.currentPlanLimitations}

                                                   {...props}/>}/>

                                <Route path="/workspace-settings"
                                       render={(props) => notVisibleOnFreePlan(props.location.pathname) ?
                                           <FreePlanPreview
                                               name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                               <InactivePlanPreview userId={user.id}
                                                                    selectedSourceNode={selected_source_node}{...props}/> :
                                               <Feeds
                                                   userFullName=''
                                                   sources={sources}
                                                   //feeds_shared={feeds_shared}
                                                   selectedSource={this.props.selectedSource}
                                                   selectedSourceNode={selected_source_node}
                                                   user={user}
                                                   toggleFeedInfo={toggleFeedInfo}
                                                   onClick={toggleConnect}
                                                   editing={this.state.editing}
                                                   user_facebook_pages={user_facebook_pages}
                                                   facebook_pages_shared={facebook_pages_shared}
                                                   addSource={this.addSource}
                                                   activateFeed={activateFeed}
                                                   deleteFeed={openModalDeleteFeed}
                                                   enablePlatform={enablePlatform}
                                                   platforms_enabled={platforms_enabled}
                                                   rss_valid={rss_valid}
                                                   openModal={openModal}
                                                   closeModal={closeModal}
                                                   appPropagateUserData={this.props.appPropagateUserData}
                                                   wp_spinner={this.props.wp_spinner}
                                                   updateUser={updateUser}
                                                   updateSources={updateSources}
                                                   selectSource={selectSource}
                                                   teams={teams}
                                                   teams_in={teams_in}
                                                   appPropagateTeams={this.props.appPropagateTeams}
                                                   updateUserFromServer={this.props.updateUserFromServer}
                                                   {...props}/>}
                                />
                                <Route path="/content-automation"
                                       render={(props) => notVisibleOnFreePlan(props.location.pathname) ?
                                           <FreePlanPreview
                                               name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                               <InactivePlanPreview userId={user.id}
                                                                    selectedSourceNode={selected_source_node}{...props}/> :
                                               <ContentAutomation
                                                   userFullName=''
                                                   sources={sources}
                                                   //feeds_shared={feeds_shared}
                                                   selectedSource={selected_source}
                                                   selectedSourceName={selected_source_node ? selected_source_node.name : ''}
                                                   user={user}
                                                   toggleFeedInfo={toggleFeedInfo}
                                                   onClick={toggleConnect}
                                                   editing={this.state.editing}
                                                   user_facebook_pages={user_facebook_pages}
                                                   facebook_pages_shared={facebook_pages_shared}
                                                   addSource={this.addSource}
                                                   activateFeed={activateFeed}
                                                   deleteFeed={openModalDeleteFeed}
                                                   enablePlatform={enablePlatform}
                                                   platforms_enabled={platforms_enabled}
                                                   rss_valid={rss_valid}
                                                   openModal={openModal}
                                                   closeModal={closeModal}
                                                   appPropagateUserData={this.props.appPropagateUserData}
                                                   wp_spinner={this.props.wp_spinner}
                                                   updateUser={updateUser}
                                                   updateSources={updateSources}
                                                   selectSource={selectSource}
                                                   teams={teams}
                                                   teams_in={teams_in}
                                                   thisSource={thisSource}
                                                   loadingSource={this.props.loadingSource}
                                                   loadingSourceChange={this.props.loadingSourceChange}
                                                   history={this.props.history}
                                                   updateUserFromServer={this.props.updateUserFromServer}
                                                   platformsEnabled={this.state.platformsEnabled}
                                                   {...props}/>}
                                />
                                <Route path="/distribution-channels"
                                       render={(props) => notVisibleOnFreePlan(props.location.pathname) ?
                                           <FreePlanPreview
                                               name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                               <InactivePlanPreview userId={user.id}
                                                                    selectedSourceNode={selected_source_node}{...props}/> :
                                               <DistributionChannels
                                                   userFullName=''
                                                   sources={sources}
                                                   //feeds_shared={feeds_shared}
                                                   selectedSource={selected_source}
                                                   user={user}
                                                   toggleFeedInfo={toggleFeedInfo}
                                                   onClick={toggleConnect}
                                                   editing={this.state.editing}
                                                   user_facebook_pages={user_facebook_pages}
                                                   facebook_pages_shared={facebook_pages_shared}
                                                   addSource={this.addSource}
                                                   activateFeed={activateFeed}
                                                   deleteFeed={openModalDeleteFeed}
                                                   enablePlatform={enablePlatform}
                                                   platforms_enabled={platforms_enabled}
                                                   rss_valid={rss_valid}
                                                   openModal={openModal}
                                                   closeModal={closeModal}
                                                   appPropagateUserData={this.props.appPropagateUserData}
                                                   wp_spinner={this.props.wp_spinner}
                                                   updateUser={updateUser}
                                                   updateSources={updateSources}
                                                   selectSource={selectSource}
                                                   teams={teams}
                                                   teams_in={teams_in}
                                                   feedActiveUpdateOnChange={true}
                                                   {...props}/>}
                                />
                                <Route path="/channels"
                                       render={(props) => notVisibleOnFreePlan(props.location.pathname) ?
                                           <FreePlanPreview
                                               name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                               <InactivePlanPreview userId={user.id}
                                                                    selectedSourceNode={selected_source_node}{...props}/> :
                                               <Channels
                                                   userFullName=''
                                                   sources={sources}
                                                   //feeds_shared={feeds_shared}
                                                   selectedSource={selected_source}
                                                   selectedSourceNode={selected_source_node}
                                                   user={user}
                                                   toggleFeedInfo={toggleFeedInfo}
                                                   onClick={toggleConnect}
                                                   editing={this.state.editing}
                                                   user_facebook_pages={user_facebook_pages}
                                                   facebook_pages_shared={facebook_pages_shared}
                                                   addSource={this.addSource}
                                                   activateFeed={activateFeed}
                                                   deleteFeed={openModalDeleteFeed}
                                                   enablePlatform={enablePlatform}
                                                   platforms_enabled={platforms_enabled}
                                                   rss_valid={rss_valid}
                                                   openModal={openModal}
                                                   closeModal={closeModal}
                                                   appPropagateUserData={this.props.appPropagateUserData}
                                                   wp_spinner={this.props.wp_spinner}
                                                   updateUser={updateUser}
                                                   updateSources={updateSources}
                                                   selectSource={selectSource}
                                                   teams={teams}
                                                   teams_in={teams_in}
                                                   feedActiveUpdateOnChange={true}
                                                   updateUserFromServer={this.props.updateUserFromServer}
                                                   tags={this.props.tags}
                                                   handleCreateTag={this.props.handleCreateTag}
                                                   handleGetTags={this.props.handleGetTags}
                                                   selectedSourceUpdated={this.state.selectedSource}
                                                   {...props}/>}
                                />

                                <Route path="/edit-profile"
                                       render={(props) => notVisibleOnFreePlan(props.location.pathname) ?
                                           <FreePlanPreview
                                               name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                               <FreePlanPreview
                                                   name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                                   <InactivePlanPreview userId={user.id}
                                                                        selectedSourceNode={selected_source_node}{...props}/> :
                                                   <Settings
                                                       openModal={openModal}
                                                       email={email}
                                                       profile_photo={profile_photo}
                                                       updatePhoto={updatePhoto}
                                                       user={user}
                                                       updateUserFromServer={this.props.updateUserFromServer}

                                                       {...props}
                                                   />}
                                />


                                <Route
                                    path='/my-campaigns'
                                    render={(props) => notVisibleOnFreePlan(props.location.pathname) ? <FreePlanPreview
                                        name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                        <InactivePlanPreview userId={user.id}
                                                             selectedSourceNode={selected_source_node}{...props}/> :
                                        <CampaignPerformance
                                            {...props}
                                            user={user}
                                            selectedSource={selected_source}
                                            selectedSourceName={selected_source_node ? selected_source_node.name : ''}
                                            selectedSourceNode={selected_source_node}
                                            //feeds_shared={feeds_shared}
                                            sources={sources}
                                            updateUser={updateUser}
                                            platforms_enabled={platforms_enabled}
                                            userFullName={localStorage.user_name}
                                            sms={this.props.plansData}
                                            user_facebook_pages={user_facebook_pages}
                                            facebook_pages_shared={facebook_pages_shared}
                                            isodateToDate={this.props.isodateToDate}
                                        />}
                                />


                                <Route path="/teams"
                                       userFullName={localStorage.user_name}

                                       render={(props) => notVisibleOnFreePlan(props.location.pathname) ?
                                           <FreePlanPreview
                                               name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                               <InactivePlanPreview userId={user.id}
                                                                    selectedSourceNode={selected_source_node}{...props}/> :
                                               <Teams
                                                   user={user}
                                                   sources={sources}
                                                   selectedSource={selected_source}
                                                   selectedSourceName={selected_source_node ? selected_source_node.name : ''}
                                                   toggleFeedInfo={this.toggleFeedInfo}
                                                   onClick={this.toggleConnect}
                                                   editing={this.state.editing}
                                                   user_facebook_pages={user_facebook_pages}
                                                   openModal={openModal}
                                                   team_name={team_name}
                                                   team_added={team_added}
                                                   teams={teams}
                                                   teams_in={teams_in}
                                                   appPropagateTeams={appPropagateTeams}
                                                   updateUserFromServer={this.props.updateUserFromServer}
                                                   history={this.props.history}
                                                   {...props}/>}
                                />

                                <Route path="/add_card" component={Subscription}/>
                                <Route path="/subscription" component={Subscription}/>
                                }

                                <Route path="/knowledge-base"
                                       render={(props) => notVisibleOnFreePlan(props.location.pathname) ?
                                           <FreePlanPreview
                                               name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                               <InactivePlanPreview userId={user.id}
                                                                    selectedSourceNode={selected_source_node}{...props}/> :
                                               <KnowledgeBase openModal={openModal}{...props}/>}/>
                                <Route path="/facebook-campaigns"
                                       render={(props) => notVisibleOnFreePlan(props.location.pathname) ?
                                           <FreePlanPreview
                                               name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                               <InactivePlanPreview userId={user.id}
                                                                    selectedSourceNode={selected_source_node}{...props}/> :
                                               <FacebookSponsoredMessage
                                                   loadingSubscribers={this.loadingSubscribers}
                                                   sources={sources}
                                                   //feeds_shared={feeds_shared}
                                                   selectedSource={selected_source}
                                                   addSource={this.addSource}
                                                   openModal={openModal}
                                                   user_facebook_pages={user_facebook_pages}
                                                   facebook_pages_shared={facebook_pages_shared}
                                                   platforms_enabled={platforms_enabled}
                                                   userFullName={getCurrentUserName()}
                                                   {...props}
                                               />}/>
                                <Route path="/acquire-subscribers"
                                       render={(props) => notVisibleOnFreePlan(props.location.pathname) ?
                                           <FreePlanPreview
                                               name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                               <InactivePlanPreview userId={user.id}
                                                                    selectedSourceNode={selected_source_node}{...props}/> :
                                               <AcquireSubscribers
                                                   loadingSubscribers={this.loadingSubscribers}
                                                   sources={sources}
                                                   //feeds_shared={feeds_shared}
                                                   selectedSource={selected_source}
                                                   checkAllPagesAndChannels={checkAllPagesAndChannels}
                                                   checkPagesAndChannels={checkPagesAndChannels}
                                                   checked_send_all={checked_send_all}
                                                   checked_channels={checked_channels}
                                                   addSource={this.addSource}
                                                   openModal={openModal}
                                                   user_facebook_pages={user_facebook_pages}
                                                   facebook_pages_shared={facebook_pages_shared}
                                                   platforms_enabled={platforms_enabled}
                                                   userFullName={getCurrentUserName()}
                                                   {...props}
                                               />}/>

                                <Route
                                    path='/tags'
                                    render={(props) => notVisibleOnFreePlan(props.location.pathname) ? <FreePlanPreview
                                        name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                        <InactivePlanPreview userId={user.id}
                                                             selectedSourceNode={selected_source_node}{...props}/> :
                                        <Tags
                                            {...props}
                                            user={user}
                                            openModal={openModal}
                                            tags={this.props.tags}
                                            tagsPageSize={this.props.tagsPageSize}
                                            selectedSource={selected_source}
                                            deleteTag={this.props.deleteTag}
                                            handleTagsSearch={this.props.handleTagsSearch}
                                            sortTagsColumn={this.props.sortTagsColumn}
                                            searchTagsString={this.props.searchTagsString}
                                            filteredTags={this.props.filteredTags}
                                            tagsLoading={this.props.tagsLoading}
                                            selected_source={this.props.selected_source}
                                            //feeds_shared={this.props.feeds_shared}
                                            addSource={this.props.addSource}
                                            updateUserFromServer={this.props.updateUserFromServer}
                                            handleGetTags={this.props.handleGetTags}
                                            isodateToDate={this.props.isodateToDate}
                                        />}
                                />
                                {/*<Route*/}
                                {/*    path='/viber-business-message'*/}
                                {/*    render={(props) => <ViberBusinessMessage*/}
                                {/*        {...props}*/}
                                {/*        openModal={openModal}*/}
                                {/*        tags={this.props.tags}*/}
                                {/*        tagsPageSize={this.props.tagsPageSize}*/}
                                {/*        selectedSource={selected_source}*/}
                                {/*        deleteTag={this.props.deleteTag}*/}
                                {/*        handleTagsSearch={this.props.handleTagsSearch}*/}
                                {/*        sortTagsColumn={this.props.sortTagsColumn}*/}
                                {/*        searchTagsString={this.props.searchTagsString}*/}
                                {/*        filteredTags={this.props.filteredTags}*/}
                                {/*        selected_source={this.props.selected_source}*/}
                                {/*        feeds_shared={this.props.feeds_shared}*/}
                                {/*        addSource={this.props.addSource}*/}
                                {/*    />}*/}
                                {/*/>*/}
                                <Route
                                    path='/url'
                                    render={(props) => notVisibleOnFreePlan(props.location.pathname) ? <FreePlanPreview
                                        name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                        <InactivePlanPreview userId={user.id}
                                                             selectedSourceNode={selected_source_node}{...props}/> :
                                        <UrlShortener
                                            {...props}
                                            history={this.props.history}
                                            selectedSource={this.props.selectedSource}
                                            //feedsShared={feeds_shared}
                                            addSource={this.addSource}
                                            user={user}
                                            currentPlanLimitations={this.state.selectedSourceFull ? this.state.selectedSourceFull[0] ? this.state.selectedSourceFull[0].plan : '' : ''}
                                            isodateToDate={this.props.isodateToDate}
                                        />}
                                />

                                <Route
                                    path='/sms-inbox'
                                    render={(props) => notVisibleOnFreePlan(props.location.pathname) ? <FreePlanPreview
                                        name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                        <InactivePlanPreview userId={user.id}
                                                             selectedSourceNode={selected_source_node}{...props}/> :
                                        <SMSInbox
                                            {...props}
                                            tags={this.props.tags}
                                            history={this.props.history}
                                            selectedSource={this.props.selectedSource}
                                            selectedSourceNode={selected_source_node}
                                            //feedsShared={feeds_shared}
                                            addSource={this.addSource}
                                            user={user}
                                            isoToDate={this.props.isodateToDate}
                                            currentPlanLimitations={this.state.selectedSourceFull[0] && this.state.selectedSourceFull[0].plan ? this.state.selectedSourceFull[0].plan : ''}
                                        />}
                                />

                                <Route
                                    path='/import-contacts'
                                    render={(props) => notVisibleOnFreePlan(props.location.pathname) ? <FreePlanPreview
                                        name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                        <InactivePlanPreview userId={user.id}
                                                             selectedSourceNode={selected_source_node}{...props}/> :
                                        <ImportContacts
                                            {...props}
                                            tags={this.props.tags}
                                            handleCreateTag={this.props.handleCreateTag}
                                            handleGetTags={this.props.handleGetTags}
                                            userId={user.id}
                                            selectedSource={selected_source}
                                        />}
                                />

                                <Route
                                    path='/contacts'
                                    render={(props) => notVisibleOnFreePlan(props.location.pathname) ? <FreePlanPreview
                                        name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                        <InactivePlanPreview userId={user.id}
                                                             selectedSourceNode={selected_source_node}{...props}/> :
                                        <Contacts
                                            {...props}
                                            tags={this.props.tags}
                                            handleCreateTag={this.props.handleCreateTag}
                                            handleGetTags={this.props.handleGetTags}
                                            userId={user.id}
                                            selectedSource={selected_source}
                                            openModal={openModal}
                                            isodateToDate={this.props.isodateToDate}
                                        />}
                                />

                                <Route
                                    path='/billing'
                                    render={(props) => notVisibleOnFreePlan(props.location.pathname) ? <FreePlanPreview
                                        name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                        <InactivePlanPreview userId={user.id}
                                                             selectedSourceNode={selected_source_node}{...props}/> :
                                        <Billing
                                            {...props}
                                            user={user}
                                            selectedSource={selected_source}
                                            selectedSourceNode={selected_source_node}
                                            //feeds_shared={feeds_shared}
                                            sources={sources}
                                            updateUser={updateUser}
                                            userFullName={localStorage.user_name}
                                            updateUserFromServer={this.props.updateUserFromServer}
                                            subscription_renewal_problem={this.props.subscription_renewal_problem || (selected_source_node && selected_source_node.name === 'Greska')}
                                            isodateToDate={this.props.isodateToDate}
                                        />}
                                />
                                <Route
                                    path="/redeem-code"
                                    render={(props) => notVisibleOnFreePlan(props.location.pathname) ? <FreePlanPreview
                                        name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                        <InactivePlanPreview userId={user.id}
                                                             selectedSourceNode={selected_source_node}{...props}/> :
                                        <RedeemCode
                                            {...props}
                                            user={user}
                                            selectedSource={selected_source}
                                            selectedSourceNode={selected_source_node}
                                            updateUserFromServer={this.props.updateUserFromServer}
                                            addSource={this.addSource}
                                        />}
                                />
                                <Route
                                    path="/custom-fields"
                                    render={(props) => notVisibleOnFreePlan(props.location.pathname) ? <FreePlanPreview
                                        name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                        <InactivePlanPreview userId={user.id}
                                                             selectedSourceNode={selected_source_node}{...props}/> :
                                        <CustomFields
                                            {...props}
                                            user={user}
                                            selectedSource={selected_source}
                                            selectedSourceNode={selected_source_node}
                                        />}
                                />
                                <Route
                                    path="/api"
                                    render={(props) => notVisibleOnFreePlan(props.location.pathname) ? <FreePlanPreview
                                        name={user.first_name}{...props}/> : notVisibleOnInactivePlan(props.location.pathname) ?
                                        <InactivePlanPreview userId={user.id}
                                                             selectedSourceNode={selected_source_node}{...props}/> :
                                        <ApiSettings
                                            {...props}
                                            user={user}
                                            selectedSource={selected_source}
                                            selectedSourceNode={selected_source_node}
                                        />}
                                />
                                <Redirect from="/" exact to="/login"/>
                                <Redirect to="/not-found"/>
                            </Switch>}
                            {/*Router starts*/}
                        </main>
                    </div>
                </div>
            </div>

            <Intercom appID={process.env.REACT_APP_INTERCOM_APP_ID}
                      {...intercomUser}
            />
        </React.Fragment>);
    }
}

export default Main;

/*
<Route path="/teams"
render={(props) => <Teams
sources={sources}
selectedSource={selected_source}
toggleFeedInfo={this.toggleFeedInfo}
onClick={this.toggleConnect}
editing={this.state.editing}
user_facebook_pages={user_facebook_pages}
openModal={openModal}
team_name={team_name}
{...props}/>}/>

<Route path="/billing"
render={(props) => <Billing
sources={sources}
selectedSource={selected_source}
toggleFeedInfo={this.toggleFeedInfo}
addCard={this.addCard}
editing={this.state.editing}
user_facebook_pages={user_facebook_pages}
{...props}/>
}/>



<StripeProvider apiKey="pk_test_C6yw0qBwEKWSZXcPxXHRGvpc00YiSTodc1">

</StripeProvider>
* */


